import React, { useEffect, useState } from "react";
import "../styles/WhatsAppFloat.css";
import { useLanguage } from "../contexts/LanguageContext";

const WhatsAppFloat = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";
  const { whatsapp, whatsappPrefill } = text.contactDetails;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!whatsapp) return null;
  const number = whatsapp.replace(/[^\d]/g, "");
  const url = `https://wa.me/${number}?text=${encodeURIComponent(whatsappPrefill)}`;
  const label = isHeb ? "וואטסאפ" : "Chat on WhatsApp";

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`whatsapp-float ${visible ? "is-visible" : ""}`}
      aria-label={label}
      title={label}
    >
      <span className="whatsapp-float-pulse" aria-hidden="true" />
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20.52 3.48A11.94 11.94 0 0 0 12.06 0C5.46 0 .12 5.34.12 11.94c0 2.1.55 4.16 1.6 5.97L0 24l6.27-1.64a11.95 11.95 0 0 0 5.79 1.48h.01c6.6 0 11.94-5.34 11.94-11.94 0-3.19-1.24-6.18-3.49-8.42zm-8.46 18.36h-.01a9.93 9.93 0 0 1-5.06-1.39l-.36-.21-3.72.98 1-3.63-.24-.37a9.93 9.93 0 0 1-1.52-5.28c0-5.49 4.47-9.96 9.96-9.96 2.66 0 5.16 1.04 7.04 2.92a9.9 9.9 0 0 1 2.92 7.04c0 5.49-4.47 9.96-9.96 9.96zm5.46-7.45c-.3-.15-1.77-.87-2.05-.97-.27-.1-.47-.15-.67.15s-.77.97-.94 1.17c-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.21 5.08 4.5.71.31 1.27.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z" />
      </svg>
    </a>
  );
};

export default WhatsAppFloat;
